import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableReceiptComponent } from './table-receipt.component';
import {SmartTableModule} from '../../modules/smart-table/smart-table.module';
import {MomentPipeModule} from '../../pipes/moment-pipe/moment-pipe.module';
import {PaginationModule} from '../../components/pagination/pagination.module';
import {PreloaderModule} from '../../components/preloader/preloader.module';
import {EntityLinkModule} from '../../components/entity-link/entity-link.module';
import {IconsModule} from '../../components/icons/icons.module';
import {NumeralPipeModule} from '../../pipes/numeral-pipe/numeral-pipe.module';



@NgModule({
  declarations: [TableReceiptComponent],
  exports: [
    TableReceiptComponent
  ],
  imports: [
    CommonModule,
    SmartTableModule,
    MomentPipeModule,
    PaginationModule,
    PreloaderModule,
    EntityLinkModule,
    IconsModule,
    NumeralPipeModule
  ]
})
export class TableReceiptModule { }
